function SearchPageHandler(product = "", event = "", data = {}) {
  const { metaData = {}, setData = {} } = data,
    {
      userId = "",
      name: userName = "",
      email: userEmail = "",
      mobile: userContact = "",
      balance = 0,
      role = "",
    } = metaData,
    { tripDetails = [], departureTimeObj = {}, tripType: trip = "" } = setData,
    {
      first = "",
      second = "",
      third = "",
      fourth = "",
      tripId = "",
    } = departureTimeObj;
  const Morning = second ? "Afternoon" : "",
    Night = first ? "Morning" : "",
    Evening = fourth ? "Night" : "",
    Afternoon = third ? "Evening" : "",
    departureFilterTime = Morning + Night + Evening + Afternoon;
  let tripDetail = tripDetails;
  if (tripDetails.length) {
    const { firstTripDetails = {} } = tripDetails;
    tripDetail = firstTripDetails;
  }
  const {
      searchId: searchIds = "",
      routeInfos = [],
      ft = "",
      cc = "",
      sI = {},
      cabinClass = "",
      isDomestic = "",
      searchType = "",
      requestId = "",
      flightSelections = [],
      tF = "",
      net = "",
      cm = "",
      finalNetFare = "",
      finalPrice = "",
      currPriceId = "",
      priceIdArr = [],
    } = tripDetail,
    { sN = "" } = sI;
  let suppliers = [];
  let supplierBrand = [];
  let fareTypes = [];
  let grossFare = finalPrice;
  let netFare = finalNetFare;
  flightSelections.map((item) => {
    const { processedTripInfo = {}, fareType = "", id = "" } = item,
      { sups = [], aI = {}, pI = [], aIs = [] } = processedTripInfo,
      { name = "" } = aI;
    if (name) {
      supplierBrand.push(name);
    }
    if (fareType) {
      fareTypes.push(fareType);
    }
    aIs.length > 0 &&
      aIs.map((data) => {
        const { name = "" } = data;
        if (name) {
          supplierBrand.push(name);
        }
      });
    if (priceIdArr.length) {
      priceIdArr.map((ids) => {
        pI.map((info) => {
          const { sI: supplierInfo = {}, id = "" } = info;
          if (ids == id) {
            const { sN = "" } = supplierInfo;
            sN && suppliers.push(sN);
          }
        });
      });
    }

    searchType == "ONEWAY" &&
      pI.map((info) => {
        const {
          id = "",
          ft = "",
          tF = "",
          net = "",
          sI: supplierInfo = {},
        } = info;
        const { sN = "" } = supplierInfo;
        if (currPriceId == id) {
          suppliers.push(sN);
          grossFare = tF;
          netFare = net;
          fareTypes.push(ft);
        }
      });
  });
  const supplier = suppliers.join(",");
  const supplierBrandName = supplierBrand.join(",");
  const finalFareType = fareTypes.join(",");
  const searchId = requestId ? requestId : searchIds;
  const isInternational = isDomestic ? false : true;
  const journeyType = isDomestic
    ? "Domestic"
    : isDomestic === false
    ? "International"
    : "";
  const [firstRouteInfo = {}] = routeInfos,
    { fromCityOrAirport = {}, toCityOrAirport = {} } = firstRouteInfo,
    {
      city: destinationCity = "",
      code: destinationCityCode = "",
      countryCode: destinationCountryCode = "",
      country: destinationCountry = "",
    } = toCityOrAirport,
    {
      city: originCity = "",
      code: originCityCode = "",
      country: originCountry = "",
    } = fromCityOrAirport;

  let tripType = "";
  trip == 0
    ? (tripType = "ONEWAY")
    : trip == 1
    ? (tripType = "ROUNDTRIP")
    : trip == 2
    ? (tripType = "MULTICITY")
    : "";
  const commmonData = {
    Identity: userId,
    walletBalance: balance,
    role,
    searchId,
    originCity: originCity,
    originCityCode: originCityCode,
    originCountry: originCountry,
    destinationCity: destinationCity,
    destinationCityCode: destinationCityCode,
    destinationCountry: destinationCountryCode,
    destinationCountry: destinationCountry,
  };
  let finalData = {};
  switch (event) {
    case "Search":
      finalData = {
        ...commmonData,
        class: cabinClass,
        isInternational,
        isDomestic,
        tripType,
        journeyType,
      };
      break;
    case "PageView":
      finalData = { ...commmonData, journeyType, tripType };
      break;
    case "ViewDetails":
      finalData = {
        ...commmonData,
        fareType: ft,
        supplier: sN,
        class: cabinClass,
        grossFare: tF,
        netFare: net,
        commission: cm,
        journeyType,
        tripType: searchType,
      };
      break;
    case "PriceSelection":
      finalData = {
        ...commmonData,
        fareType: ft,
        supplier: sN,
        class: cabinClass,
        grossFare: tF,
        netFare: net,
        commission: cm,
        journeyType,
        tripType: searchType,
      };
      break;
    case "Filter_netfare":
      finalData = { ...commmonData };
      break;
    case "Filter_incv":
      finalData = { ...commmonData };
      break;
    case "ShareViaWP":
      finalData = {
        ...commmonData,
        journeyType,
        class: cabinClass,
        tripType: searchType,
      };
      break;
    case "ShareViaEmail":
      finalData = {
        ...commmonData,
        journeyType,
        class: cabinClass,
        tripType: searchType,
      };
      break;
    case "Filter_Departure":
      finalData = { ...commmonData, departureFilterTime, tripId };
      break;
    case "Book":
      finalData = {
        ...commmonData,
        fareType: finalFareType,
        supplier: sN ? sN : supplier,
        class: cabinClass,
        searchType,
        supplierBrand: supplierBrandName,
        grossFare: grossFare,
        netFare: netFare,
        journeyType,
      };
      break;
  }
  return finalData;
}

module.exports = { SearchPageHandler };
